import React, { Fragment, useEffect, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';

import { buscarProveedoresProducto, limpiarProveedoresProducto } from '../../../actions/configuracion';
import { formatNumber } from '../../../utils/generalFunctions';

const ProveedoresProducto = ({ producto, reestablecerProducto }) => {

    const dispatch = useDispatch();
    const { listado } = useSelector(state => state.configuracion.proveedores_producto);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    useEffect(() => {
        if (producto?._id) {
            dispatch(buscarProveedoresProducto(producto._id));
        }

        return () => {
            dispatch(limpiarProveedoresProducto());
        };
    }, [producto?._id]);

    const handleClose = () => {
        dispatch(limpiarProveedoresProducto());
        reestablecerProducto(null);
    };

    const columns = useMemo(() => ([
        {
            name: 'Proveedor',
            selector: row => row?.proveedor?.nombre || 'Sin definir',
            sortable: true,
            wrap: true,
            grow: 2
        },
        {
            name: 'Código proveedor',
            selector: row => row?.codigo || 'Sin definir',
            sortable: true,
            wrap: true
        },
        {
            name: 'Último precio compra',
            selector: row => formatNumber(row?.precio_historico || 0, 2, '$ ', ''),
            sortable: true,
            right: true,
            wrap: true
        },
        {
            name: 'Precio público',
            selector: row => formatNumber(row?.precio_publico || 0, 2, '$ ', ''),
            sortable: true,
            right: true,
            wrap: true
        },
        {
            name: 'Precio mínimo',
            selector: row => formatNumber(row?.precio_minimo || 0, 2, '$ ', ''),
            sortable: true,
            right: true,
            wrap: true
        },
        {
            name: 'Liquidación',
            selector: row => formatNumber(row?.precio_liquidacion || 0, 2, '$ ', ''),
            sortable: true,
            right: true,
            wrap: true
        }
    ]), []);

    return (
        <Fragment>
            <Modal show={!!producto} onHide={handleClose} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Proveedores del producto
                        {producto?.nombre ? <span className="text-muted"> — {producto.nombre}</span> : null}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="mb-3 text-muted">
                        {producto?.codigo ? `Código: ${producto.codigo}` : null}
                    </div>

                    <DataTable
                        columns={columns}
                        data={listado || []}
                        pagination
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[5, 10, 20, 50]}
                        paginationComponentOptions={paginationOptions}
                        highlightOnHover
                        persistTableHead
                        noDataComponent="No hay proveedores ligados a este producto."
                    />
                </Modal.Body>

                <Modal.Footer>
                    <button type="button" className="btn btn-outline-secondary" onClick={handleClose}>
                        Cerrar
                    </button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default ProveedoresProducto;
